import { apiFetch } from '@/config/api.js'

// 获取设备信息
function getDeviceInfo() {
  const ua = navigator.userAgent
  let browser = 'Unknown'
  let os = 'Unknown'
  
  // 检测浏览器
  if (ua.indexOf('Chrome') > -1) browser = 'Chrome'
  else if (ua.indexOf('Safari') > -1) browser = 'Safari'
  else if (ua.indexOf('Firefox') > -1) browser = 'Firefox'
  else if (ua.indexOf('Edge') > -1) browser = 'Edge'
  
  // 检测操作系统
  if (ua.indexOf('Windows') > -1) os = 'Windows'
  else if (ua.indexOf('Mac') > -1) os = 'macOS'
  else if (ua.indexOf('Linux') > -1) os = 'Linux'
  else if (ua.indexOf('Android') > -1) os = 'Android'
  else if (ua.indexOf('iOS') > -1) os = 'iOS'
  
  return `${browser} on ${os}`
}

// 登录接口：调用后端 POST /api/login
// 请求体：{ account, password, deviceInfo }
// 返回：{ code, msg, data? }
export async function login(account, password) {
  // 与 uni-app 保持一致：POST /api/auth/login
  return apiFetch('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ 
      account, 
      password,
      deviceInfo: getDeviceInfo()
    })
  })
}

// 修改密码接口：调用后端 POST /api/auth/change-password
// 请求体：{ newPassword }
// 返回：{ code, msg }
export async function changePassword(newPassword) {
  return apiFetch('/api/auth/change-password', {
    method: 'POST',
    body: JSON.stringify({ newPassword })
  })
}

// 获取当前用户信息（用于刷新到期时间等）
// GET /api/auth/me
// 返回：{ code, msg, data: { account, role, expireDays, isGuest, hasGuestPassword } }
export async function getCurrentUser() {
  return apiFetch('/api/auth/me', {
    method: 'GET'
  })
}

// 设置访客密码（仅主账号可用）
// POST /api/auth/set-guest-password
// 请求体：{ guestPassword }
// 返回：{ code, msg }
export async function setGuestPassword(guestPassword) {
  return apiFetch('/api/auth/set-guest-password', {
    method: 'POST',
    body: JSON.stringify({ guestPassword })
  })
}

// 更新访客权限（仅主账号可用）
// POST /api/auth/guest-permissions
// 请求体：{ guestCanSpend?, guestCanRecharge? }
// 返回：{ code, msg }
export async function updateGuestPermissions(permissions) {
  return apiFetch('/api/auth/guest-permissions', {
    method: 'POST',
    body: JSON.stringify(permissions)
  })
}